import React from 'react';
import Accordion from '@material-ui/core/Accordion';

const CustomAccordion = (props) => {
    return <Accordion {...props} />;
};

export { CustomAccordion as Accordion };
